import React from 'react';
import Input from '../components/Input';
import DropDown from '../components/SDL/DropDown';
import HiddenInput from '../components/SDL/HiddenInput';

/**
 * This component will render the Component that corresponds to the inputControl prop
 *
 */

export default function InputControl({ inputControl, form, ...props }) {
    switch (inputControl) {
        case 'Hidden':
            return <HiddenInput {...props} />;
        case 'TextField':
            return <Input {...props} />;
        case 'DropDown':
            return <DropDown form={form} {...props} />;
        case 'Checkbox':
            return null;
        case 'AutoComplete':
            return null;
        default:
            return null;
    }
}
